// extracted by mini-css-extract-plugin
export default {"tooltipTrigger":"J2oy72sv3kCEWKNrjhoe","tooltip":"fhcVXEwAzEyUkQ_OON0w"};